<template>
  <div class="studyplan-apply">
    <div class="goods-selected">
      <div class="selected-name">
        <span>{{
          hasSelect
            ? `已选择：${selectedPlan.goodsName}`
            : '未选择计划'
          }}</span>
      </div>
      <div class="selected-tip">只能选择一个计划</div>
    </div>
    <div class="btn-apply" @click="apply">
      <div class="btn-text">开启<br/>友邻学习计划</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'studyplan-apply',
  data() {
    return {
      form: {
        albumName: '篝火计划'
      }
    }
  },
  computed: {
    ...mapGetters('goods-studyplan/plan', [
      'selectedPlan'
    ]),
    hasSelect() {
      return this.selectedPlan.goodsId > 0
    }
  },
  methods: {
    apply() {
      this.$emit('click', this.selectedPlan)
    }
  }
}
</script>

<style lang="less" scoped>
.studyplan-apply {
  width: 100%;
  height: 1.3rem;
  background: url("../../../../../images/goods-studyplan/buttom_bar.png") no-repeat;
  background-size: 100% 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  // iphoneX only
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  .goods-selected {
    flex: 1;
    color: rgba(104, 49, 0, 0.8);
    .selected-name {
      margin: 0.3rem 0.28rem 0 0.28rem;
      font-size: 0.26rem;
      font-weight: bold;
      line-height: 0.37rem;
    }
    .selected-tip {
      margin: 0.07rem 0.28rem 0 0.28rem;
      font-size: 0.19rem;
      line-height: 0.26rem;
    }
  }
  .btn-apply {
    width: 3.43rem;
    height: 1.49rem;
    margin-top: -0.19rem;
    background: url("../../../../../images/goods-studyplan/buttom_bar_apply.png") no-repeat;
    background-size: 100% 100%;
    .btn-text {
      font-size: 0.34rem;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 0.47rem;
      padding: 0.28rem 0.36rem 0.28rem 0.36rem;
      text-align: center;
    }
  }
}
</style>